/**
 * Genera un codice univoco per una bozza ordine.
 *
 * Formato: BZZ-{YYYYMMDD}-{AGENT6}-{RAND4}
 * - AGENT6: prime 6 cifre alfanumeriche del sub UUID dell'agente (o random se non disponibile)
 * - RAND4:  4 caratteri alfanumerici casuali
 *
 * @example BZZ-20250303-550E84-3F9A
 */
export function generateDraftCode(agentSub: string | null, date: string): string {
    const dateStr = date.replace(/-/g, '');
    const agentPart = agentSub
        ? agentSub.replace(/-/g, '').substring(0, 6).toUpperCase()
        : Math.random().toString(36).substring(2, 8).toUpperCase();
    const random = Math.random().toString(36).substring(2, 6).toUpperCase();
    return `BZZ-${dateStr}-${agentPart}-${random}`;
}
